/**
 * Request to create a preorder/an order in the DMS.
 */
import { TechnicalHeaderInRequest } from '../common/technical-header-in-request';
import { FunctionalHeader } from '../common/functional-header';
import { UserInformation } from '../common/user-information';
import { CreateServiceOrderRequestBody } from './create-service-order-request-body';
import { DmsRequest } from '../common/dms-request';

export class CreateServiceOrderRequest implements DmsRequest {
  readonly simpleName = 'create-order';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: CreateServiceOrderRequestBody;
}
